import { createActions, createReducer, resettableReducer } from 'reduxsauce';
import { types as loginTypes } from '../../auth/login';

/**
 * New module — Home (mobile) dispatched to a `coupons/followedCoupons` duck
 * that doesn't exist anywhere in the redux store (web or the mobile
 * `businesses` zip); only the backing API call
 * (coupons/api.js -> getCouponsByBusinessIds) exists. Built here following
 * the same shape/conventions as the rest of customerCoupons.
 *
 * Fetches the coupons belonging to a given list of business ids (i.e. "show
 * me what my followed businesses are currently offering"). Not paginated —
 * the mobile screen treats the response as a flat array.
 */

export const INITIAL_STATE = {
  fetching: false,
  fetched: false,
  data: [],
  error: null,
};

const { Types, Creators } = createActions(
  {
    getCouponsByBusinessIds: ['businessIds'],
    getCouponsByBusinessIdsRequest: [],
    getCouponsByBusinessIdsSuccess: ['data'],
    getCouponsByBusinessIdsFailure: ['error'],
  },
  { prefix: 'cb/customerCoupons/followedCoupons/' },
);

export { Types as types, Creators as actions };

const request = state => ({
  ...state,
  fetching: true,
  error: null,
});

const success = (state, { data }) => ({
  ...state,
  fetching: false,
  fetched: true,
  data: Array.isArray(data) ? data : (data && data.results) || [],
});

const failure = (state, { error }) => ({
  ...state,
  fetching: false,
  fetched: true,
  error,
});

export const HANDLERS = {
  [Types.GET_COUPONS_BY_BUSINESS_IDS_REQUEST]: request,
  [Types.GET_COUPONS_BY_BUSINESS_IDS_SUCCESS]: success,
  [Types.GET_COUPONS_BY_BUSINESS_IDS_FAILURE]: failure,
};

export default resettableReducer(loginTypes.LOGOUT)(createReducer(INITIAL_STATE, HANDLERS));